var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"posters"}},_vm._l((_vm.posters),function(item){return _c('poster-item',{key:item.id,attrs:{"poster":item}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }